import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  withStateHandlers,
  withProps,
  lifecycle,
} from 'recompose';

import formControl from './formControl';

const CHECKED = true;
const UNCHECKED = false;
const INDETERMINATE = null;

const IndeterminateCheckbox = ({ value, onChange }) => {
  const checkRef = useRef();
  useEffect(() => {
    checkRef.current.checked = value === CHECKED;
    checkRef.current.indeterminate = value === INDETERMINATE;
  });
  return (
    <input
      type="checkbox"
      ref={checkRef}
      style={{
        marginRight: '15px',
      }}
      onChange={onChange}
    />
  );
};

IndeterminateCheckbox.propTypes = {
  value: PropTypes.oneOf([CHECKED, UNCHECKED, INDETERMINATE]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default compose(
  withProps({
    type: 'checkbox',
  }),
  formControl,
  withStateHandlers(({ input: { value } }) => ({
    value: typeof value !== 'boolean' ? null : value,
  }), {
    onChange: ({ value }, props) => () => {
      if (value === CHECKED) {
        props.input.onChange(UNCHECKED);
        return {
          value: UNCHECKED,
        };
      }
      if (value === INDETERMINATE) {
        props.input.onChange(CHECKED);
        return {
          value: CHECKED,
        };
      }
      props.input.onChange(INDETERMINATE);
      return {
        value: INDETERMINATE,
      };
    },
    setValue: () => (value) => ({
      value,
    }),
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (this.props.input.value !== prevProps.input.value) {
        if (this.props.input.value === false || this.props.input.value === true) {
          this.props.setValue(this.props.input.value);
        } else {
          this.props.setValue(INDETERMINATE);
        }
      }
    },
  }),
)(IndeterminateCheckbox);
